exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-page-builder-tsx": () => import("./../../../src/templates/page-builder.tsx" /* webpackChunkName: "component---src-templates-page-builder-tsx" */),
  "component---src-templates-products-products-tsx": () => import("./../../../src/templates/products/products.tsx" /* webpackChunkName: "component---src-templates-products-products-tsx" */)
}

